import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../../assets/promiseFrame/268V_Icon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-aee1eeb4")

_pushScopeId("data-v-aee1eeb4")
const _hoisted_1 = { class: "headTip" }
const _hoisted_2 = { class: "topText" }
const _hoisted_3 = { class: "topText_flex" }
const _hoisted_4 = { class: "carBrand" }
const _hoisted_5 = {
  key: 0,
  class: "brandlogo_wrapper"
}
const _hoisted_6 = { class: "topText_one" }
const _hoisted_7 = { class: "topTags" }
const _hoisted_8 = {
  key: 0,
  class: "topText_xny"
}
const _hoisted_9 = {
  key: 1,
  class: ""
}
const _hoisted_10 = { class: "productname_wrapper productname_bg" }
const _hoisted_11 = { class: "topText_small" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "topText_small_shallow" }, "*The vehicle models are for reference only.", -1)
const _hoisted_13 = { class: "head_promise_result_wrap" }
const _hoisted_14 = { class: "head_promise_wrapper" }
const _hoisted_15 = { class: "vector_description" }
const _hoisted_16 = { class: "promiseMsg head_promise_font_299" }
const _hoisted_17 = { class: "result_wrap" }
const _hoisted_18 = { class: "resBox_top" }
const _hoisted_19 = { class: "reportLevel" }
const _hoisted_20 = /*#__PURE__*/_createVNode("i", { class: "iconfont icon-gantanhao" }, null, -1)
const _hoisted_21 = { class: "top_levelDes" }
const _hoisted_22 = { class: "resbox_bottom" }
const _hoisted_23 = { class: "rectangle_resBox" }
const _hoisted_24 = {
  key: 0,
  class: "rectangle_resBox_item"
}
const _hoisted_25 = { class: "rectangle_resBox_item_txt" }
const _hoisted_26 = {
  key: 1,
  class: "rectangle_resBox_item"
}
const _hoisted_27 = { class: "rectangle_resBox_item_txt" }
const _hoisted_28 = {
  key: 2,
  class: "rectangle_resBox_item"
}
const _hoisted_29 = { class: "rectangle_resBox_item_txt" }
const _hoisted_30 = {
  key: 3,
  class: "rectangle_resBox_item"
}
const _hoisted_31 = { class: "rectangle_resBox_item_txt" }
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "result_line" }, null, -1)
const _hoisted_33 = { class: "result_bottom" }
const _hoisted_34 = /*#__PURE__*/_createVNode("img", {
  class: "localIcon",
  src: _imports_0
}, null, -1)
const _hoisted_35 = { class: "toc_ui__headTip_content_report_num" }
const _hoisted_36 = { class: "batteryPop" }
const _hoisted_37 = { class: "batteryPopTitle" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Rating Guide ")
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "batteryPopTitleLine" }, null, -1)
const _hoisted_40 = { class: "batteryPopCont" }
const _hoisted_41 = /*#__PURE__*/_createVNode("div", { class: "batteryPopContTitle" }, [
  /*#__PURE__*/_createVNode("i", { class: "batteryPopContTitleLine" }),
  /*#__PURE__*/_createVNode("span", { class: "batteryPopContTitleTxt" }, "Overall Vehicle Condition")
], -1)
const _hoisted_42 = { class: "scoreLevelList" }
const _hoisted_43 = { class: "scoreLevelItem" }
const _hoisted_44 = { class: "scoreLevelInfo" }
const _hoisted_45 = /*#__PURE__*/_createVNode("div", { class: "scoreLevelDesc" }, "Only minor surface scratches are present, with no signs of repair. The interior is nearly new, with no obvious signs of use. The engine and transmission are in excellent operating condition, and all electrical equipment functions normally.", -1)
const _hoisted_46 = { class: "scoreLevelItem" }
const _hoisted_47 = { class: "scoreLevelInfo" }
const _hoisted_48 = /*#__PURE__*/_createVNode("div", { class: "scoreLevelDesc" }, "Minor exterior defects and traces of body and paint repair are present without affecting the vehicle's overall appearance. The interior shows slight signs of use but remains clean and tidy. The engine and transmission operate steadily. All electrical equipment functions normally, with no faults or damage to major components.", -1)
const _hoisted_49 = { class: "scoreLevelItem" }
const _hoisted_50 = { class: "scoreLevelInfo" }
const _hoisted_51 = /*#__PURE__*/_createVNode("div", { class: "scoreLevelDesc" }, "The exterior has multiple defects, with traces of body and paint repair in some areas. Interior wear is clearly visible. Some vehicle components show signs of aging, and occasional faults may occur.", -1)
const _hoisted_52 = { class: "scoreLevelItem" }
const _hoisted_53 = { class: "scoreLevelInfo" }
const _hoisted_54 = /*#__PURE__*/_createVNode("div", { class: "scoreLevelDesc" }, "Numerous exterior defects affect the vehicle's overall appearance. The interior is heavily worn, with damage in some areas. The engine and transmission show significant wear, accompanied by oil leaks, abnormal noise, or similar issues. Repair and maintenance costs are likely to increase.", -1)
const _hoisted_55 = { class: "scoreLevelItem" }
const _hoisted_56 = { class: "scoreLevelInfo" }
const _hoisted_57 = /*#__PURE__*/_createVNode("div", { class: "scoreLevelDesc" }, "The exterior has undergone extensive body repairs and has numerous defects. The interior is severely worn and heavily damaged. The engine and transmission have major oil leaks and obvious abnormal noise, creating potential driving safety risks. The chassis is loose and severely aged. Most electrical equipment is inoperative, and future reconditioning and repair costs will be high.", -1)
const _hoisted_58 = /*#__PURE__*/_createStaticVNode("<div class=\"batteryPopContTitle\" data-v-aee1eeb4><i class=\"batteryPopContTitleLine\" data-v-aee1eeb4></i><span class=\"batteryPopContTitleTxt\" data-v-aee1eeb4>Accident Damage Rating</span></div><div class=\"accidentLevelList\" data-v-aee1eeb4><div class=\"accidentLevelItem\" data-v-aee1eeb4><div class=\"accidentLevelIcon level-a\" data-v-aee1eeb4>A</div><div class=\"accidentLevelDesc\" data-v-aee1eeb4>No structural or reinforcement components show accident damage or repair. No exterior body panels (excluding plastic parts) have been repaired. No fire or flood damage is present.</div></div><div class=\"accidentLevelItem\" data-v-aee1eeb4><div class=\"accidentLevelIcon level-b\" data-v-aee1eeb4>B</div><div class=\"accidentLevelDesc\" data-v-aee1eeb4>No structural components show accident damage or repair. Reinforcement components have no welding or cutting repairs. Repairs to exterior body panels are permitted. No fire or flood damage is present.</div></div><div class=\"accidentLevelItem\" data-v-aee1eeb4><div class=\"accidentLevelIcon level-c\" data-v-aee1eeb4>C</div><div class=\"accidentLevelDesc\" data-v-aee1eeb4>No structural components show accident damage or repair. Reinforcement components have undergone welded repairs. No fire or flood damage is present.</div></div><div class=\"accidentLevelItem\" data-v-aee1eeb4><div class=\"accidentLevelIcon level-c\" data-v-aee1eeb4>D</div><div class=\"accidentLevelDesc\" data-v-aee1eeb4>Structural components have accident damage or repairs, reinforcement components have undergone cutting repairs, or the vehicle has fire or flood damage.</div></div></div>", 2)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_popup = _resolveComponent("van-popup")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            (_ctx.getData('brandLogo'))
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  _createVNode("img", {
                    src: _ctx.getData('brandLogo'),
                    class: "topText_brandlogo"
                  }, null, 8, ["src"])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_6, _toDisplayString(_ctx.getData("brandSeriesName")), 1)
          ]),
          _createVNode("div", _hoisted_7, [
            (_ctx.getData('energyType') === '2')
              ? (_openBlock(), _createBlock("div", _hoisted_8, "NEVs"))
              : _createCommentVNode("", true),
            (_ctx.getData('detectItem'))
              ? (_openBlock(), _createBlock("div", _hoisted_9, [
                  _createVNode("div", _hoisted_10, [
                    _createVNode("span", {
                      class: "productname_font productname",
                      text: _ctx.getData('detectItem')
                    }, _toDisplayString(_ctx.getData("detectItem")), 9, ["text"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_11, "VIN: " + _toDisplayString(_ctx.getData("VIN")), 1),
        _hoisted_12
      ]),
      _createVNode("div", _hoisted_13, [
        (_ctx.state.showProtect)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: "head_promise_bg head_promise_bg_299",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toExplain()))
            }, [
              _createVNode("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, [
                  _createVNode("span", _hoisted_16, _toDisplayString(_ctx.state.promiseTxt), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", {
          class: ["head_result_bg", {'head_result_sf_bg': _ctx.state.showProtect,
                'head_result_sf_bg_noguarantee result_bg_nosf': !_ctx.state.showProtect}]
        }, [
          _createVNode("div", _hoisted_17, [
            _createVNode("div", {
              class: ["result_middle", {"result_middle_nosf": !_ctx.state.showProtect}]
            }, [
              _createVNode("div", _hoisted_18, [
                _createVNode("div", _hoisted_19, [
                  _createVNode("h5", {
                    class: "levelTxt",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changePop && _ctx.changePop(...args)))
                  }, [
                    _createVNode("img", {
                      class: "levelNum",
                      src: require(`../../../../../assets/promiseFrame/${_ctx.getData('rank')}.png`),
                      alt: ""
                    }, null, 8, ["src"]),
                    _hoisted_20
                  ])
                ]),
                _createVNode("div", _hoisted_21, _toDisplayString(_ctx.getData('rankDesc')), 1)
              ]),
              _createVNode("div", _hoisted_22, [
                _createVNode("ul", _hoisted_23, [
                  (_ctx.getData('accidentFlag', 'additionUrl'))
                    ? (_openBlock(), _createBlock("li", _hoisted_24, [
                        _createVNode("img", {
                          src: require(`../../../../../assets/promiseFrame/${_ctx.getData('accidentFlag', 'additionUrl')}`),
                          alt: ""
                        }, null, 8, ["src"]),
                        _createVNode("p", _hoisted_25, _toDisplayString(_ctx.getData('accidentFlag')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.getData('fireFlag', 'additionUrl'))
                    ? (_openBlock(), _createBlock("li", _hoisted_26, [
                        _createVNode("img", {
                          src: require(`../../../../../assets/promiseFrame/${_ctx.getData('fireFlag', 'additionUrl')}`),
                          alt: ""
                        }, null, 8, ["src"]),
                        _createVNode("p", _hoisted_27, _toDisplayString(_ctx.getData('fireFlag')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.getData('waterFlag', 'additionUrl'))
                    ? (_openBlock(), _createBlock("li", _hoisted_28, [
                        _createVNode("img", {
                          src: require(`../../../../../assets/promiseFrame/${_ctx.getData('waterFlag', 'additionUrl')}`),
                          alt: ""
                        }, null, 8, ["src"]),
                        _createVNode("p", _hoisted_29, _toDisplayString(_ctx.getData('waterFlag')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.getData('adjustFlag', 'additionUrl'))
                    ? (_openBlock(), _createBlock("li", _hoisted_30, [
                        _createVNode("img", {
                          src: require(`../../../../../assets/promiseFrame/${_ctx.getData('adjustFlag', 'additionUrl')}`),
                          alt: ""
                        }, null, 8, ["src"]),
                        _createVNode("p", _hoisted_31, _toDisplayString(_ctx.getData('adjustFlag')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 2),
            _hoisted_32,
            _createVNode("div", _hoisted_33, [
              _hoisted_34,
              _createVNode("span", _hoisted_35, " NO." + _toDisplayString(_ctx.getData('reportCode')) + " " + _toDisplayString(_ctx.getData('reportGenDate') ? `| ${_ctx.getData('reportGenDate').replace(/-/g,'.')}` : ''), 1)
            ])
          ])
        ], 2)
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.state.isShowPop,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.isShowPop = $event)),
      round: "",
      position: "bottom"
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_36, [
          _createVNode("div", _hoisted_37, [
            _hoisted_38,
            _createVNode("i", {
              class: "iconfont icon-guanbi",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.changePop && _ctx.changePop(...args)))
            })
          ]),
          _hoisted_39,
          _createVNode("div", _hoisted_40, [
            _hoisted_41,
            _createVNode("div", _hoisted_42, [
              _createVNode("div", _hoisted_43, [
                _createVNode("div", _hoisted_44, [
                  _createVNode("img", {
                    class: "scoreLevelNum",
                    src: require('../../../../../assets/promiseFrame/95en.png'),
                    alt: ""
                  }, null, 8, ["src"])
                ]),
                _hoisted_45
              ]),
              _createVNode("div", _hoisted_46, [
                _createVNode("div", _hoisted_47, [
                  _createVNode("img", {
                    class: "scoreLevelNum",
                    src: require('../../../../../assets/promiseFrame/80en.png'),
                    alt: ""
                  }, null, 8, ["src"])
                ]),
                _hoisted_48
              ]),
              _createVNode("div", _hoisted_49, [
                _createVNode("div", _hoisted_50, [
                  _createVNode("img", {
                    class: "scoreLevelNum",
                    src: require('../../../../../assets/promiseFrame/65en.png'),
                    alt: ""
                  }, null, 8, ["src"])
                ]),
                _hoisted_51
              ]),
              _createVNode("div", _hoisted_52, [
                _createVNode("div", _hoisted_53, [
                  _createVNode("img", {
                    class: "scoreLevelNum",
                    src: require('../../../../../assets/promiseFrame/50en.png'),
                    alt: ""
                  }, null, 8, ["src"])
                ]),
                _hoisted_54
              ]),
              _createVNode("div", _hoisted_55, [
                _createVNode("div", _hoisted_56, [
                  _createVNode("img", {
                    class: "scoreLevelNum",
                    src: require('../../../../../assets/promiseFrame/35en.png'),
                    alt: ""
                  }, null, 8, ["src"])
                ]),
                _hoisted_57
              ])
            ]),
            _hoisted_58
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
})